import * as React from 'react'

import { MANIFESTO_URL, MISSION_QUOTE } from '../content'
import styles from './Mission.module.css'

/** Mission panel — a white bordered card rendered inside the white "makers" section. */
export function Mission(): React.ReactElement {
  return (
    <div className={styles.mission}>
      <blockquote className={styles.mission__quote}>
        <p>{MISSION_QUOTE}</p>
        <a className={styles.mission__manifesto} href={MANIFESTO_URL}>
          Lire notre manifeste →
        </a>
      </blockquote>
    </div>
  )
}
